import { defineStore } from "pinia";
import { ref } from "vue";

// import { v4 as uuidv4 } from 'uuid';

import { useRouter } from "vue-router";
import { useSound } from "@/service/sound"

export const useSharedStore = defineStore('sharedStore', () => {

    const router = useRouter();
    const soundService = useSound()
    
    const receivedFiles = ref([]);
    const receivedFields = ref({});
    const receivedPayload = ref({});
    const when = ref(null);

    const init = () => {
        if (navigator?.serviceWorker) {
            console.log("👂 listening for shared data")
            navigator?.serviceWorker.addEventListener("message", (event) => {
                soundService.play('info')
                processShareEvent(event);
                router.push({ name: 'client-receive-shared-files' , event: event })
            });
        }
        else {
            console.log("🚫 service worker not found")
        }
    }

    /**
     * Function that processes the received share event from the Service Worker.
     * @param {Object} event - { general: {...}, files: [...] }
     */
    function processShareEvent(event) {

        console.log(event);

        const payload = event.data.payload
        const type = event.data.type
        // now payload contains 
            //   const payload = {
            //       fields: {},
            //       files: [],
            //   };

        // reset
        receivedFiles.value = []
        receivedFields.value = {}
        when.value = null


        when.value = new Date(Date.now());

        console.log(payload);
        console.log(type);

        if (type !== 'SHARE_DATA') {
            console.log('Received unknown message type from Service Worker.');
            // return;
        }
        else{
            console.log('Processing shared payload from Service Worker. Rimuovere questo else (vuol dire ce l IF funziona)');
        }

        if (!payload) {
            console.log('No payload found in the message.');
            return;
        }

        // Extract standard share parameters (text, url, title)
        receivedPayload.value = payload || {}
        receivedFields.value = payload?.fields || {}
        receivedFiles.value = payload?.files || []
        
        // 1. Update general data (optional, but good practice)


        console.log(`Payload processed. Total files: ${receivedFiles.value.length}`);
    }



    return {
        init,
        when,
        receivedFiles,
        receivedFields,
        receivedPayload,
    }
})
